module.exports = __webpack_public_path__ + "img/bus.6c6d1984.svg";